import React, { useRef, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';

function VideoPlayer({ video, progress, autoplay, onWatch }) {
  const playerRef = useRef(null);
  const [muted, setMuted] = useState(false);
  const hasPlayedRef = useRef(false);
  const autoplayFallbackTimerRef = useRef(null);

  useEffect(() => {
    if (playerRef.current && progress) {
      // Uncomment if you want to resume from a saved progress:
      // playerRef.current.seekTo(progress / 100, 'fraction');
    }
  }, [video, progress]);

  useEffect(() => {
    // Reset playback/mute state when the video changes.
    hasPlayedRef.current = false;
    setMuted(false);

    if (autoplayFallbackTimerRef.current) {
      clearTimeout(autoplayFallbackTimerRef.current);
      autoplayFallbackTimerRef.current = null;
    }

    // Autoplay with sound is often blocked without a user gesture.
    // Try with sound first; if it doesn't start quickly, retry muted.
    if (autoplay) {
      autoplayFallbackTimerRef.current = setTimeout(() => {
        if (!hasPlayedRef.current) setMuted(true);
      }, 1500);
    }

    return () => {
      if (autoplayFallbackTimerRef.current) {
        clearTimeout(autoplayFallbackTimerRef.current);
        autoplayFallbackTimerRef.current = null;
      }
    };
  }, [video?.url, autoplay]);

  const handleProgress = (progressData) => {
    const percentage = progressData.played * 100;
    console.log(`Video progress: ${percentage}%`);
    onWatch(percentage);
  };

  return (
    <div 
      className="video-player-wrapper" 
      style={{ position: 'relative', width: '100%', paddingBottom: '56.25%' }} // 16:9 ratio
    >
      <ReactPlayer
        ref={playerRef}
        url={video.url}
        controls
        onProgress={handleProgress}
        muted={muted}
        playing={autoplay}
        onPlay={() => {
          hasPlayedRef.current = true;
          if (autoplayFallbackTimerRef.current) {
            clearTimeout(autoplayFallbackTimerRef.current);
            autoplayFallbackTimerRef.current = null;
          }

          // If we got a successful play event, prefer sound.
          setMuted(false);
        }}
        width="100%"
        height="100%"
        style={{ position: 'absolute', top: 0, left: 0 }} // Ensure it fills wrapper
      />
    </div>
  );
}

export default VideoPlayer;
